// Auto-generated lesson registry — import all 50 lessons + legacy intro
import introLesson from './intro-to-python.json';
import c01 from './class-01-hello-python.json';
import c02 from './class-02-variables.json';
import c03 from './class-03-numbers.json';
import c04 from './class-04-strings.json';
import c05 from './class-05-user-input.json';
import c06 from './class-06-booleans.json';
import c07 from './class-07-comparisons.json';
import c08 from './class-08-if-statements.json';
import c09 from './class-09-if-else.json';
import c10 from './class-10-if-elif-else.json';
import c11 from './class-11-while-loops.json';
import c12 from './class-12-for-loops.json';
import c13 from './class-13-loop-control.json';
import c14 from './class-14-nested-loops.json';
import c15 from './class-15-lists-intro.json';
import c16 from './class-16-list-methods.json';
import c17 from './class-17-looping-lists.json';
import c18 from './class-18-tuples.json';
import c19 from './class-19-dictionaries.json';
import c20 from './class-20-dict-methods.json';
import c21 from './class-21-sets.json';
import c22 from './class-22-defining-functions.json';
import c23 from './class-23-parameters.json';
import c24 from './class-24-return-values.json';
import c25 from './class-25-scope.json';
import c26 from './class-26-default-params.json';
import c27 from './class-27-string-methods.json';
import c28 from './class-28-string-formatting.json';
import c29 from './class-29-string-slicing.json';
import c30 from './class-30-nested-lists.json';
import c31 from './class-31-list-comprehensions.json';
import c32 from './class-32-sorting-searching.json';
import c33 from './class-33-files.json';
import c34 from './class-34-error-types.json';
import c35 from './class-35-try-except.json';
import c36 from './class-36-raising-errors.json';
import c37 from './class-37-math-module.json';
import c38 from './class-38-random-module.json';
import c39 from './class-39-datetime-module.json';
import c40 from './class-40-lambda.json';
import c41 from './class-41-classes-intro.json';
import c42 from './class-42-init-attributes.json';
import c43 from './class-43-methods.json';
import c44 from './class-44-inheritance.json';
import c45 from './class-45-special-methods.json';
import c46 from './class-46-recursion.json';
import c47 from './class-47-map-filter.json';
import c48 from './class-48-sorting-algorithms.json';
import c49 from './class-49-data-analysis.json';
import c50 from './class-50-capstone.json';

// Ordered list used for navigation — defines unit groupings
export const UNITS = [
  {
    title: 'Getting Started',
    lessons: [c01, c02, c03, c04, c05],
  },
  {
    title: 'Making Decisions',
    lessons: [c06, c07, c08, c09, c10],
  },
  {
    title: 'Loops',
    lessons: [c11, c12, c13, c14],
  },
  {
    title: 'Collections',
    lessons: [c15, c16, c17, c18, c19, c20, c21],
  },
  {
    title: 'Functions',
    lessons: [c22, c23, c24, c25, c26],
  },
  {
    title: 'Strings Deep Dive',
    lessons: [c27, c28, c29],
  },
  {
    title: 'Data & Files',
    lessons: [c30, c31, c32, c33],
  },
  {
    title: 'Error Handling',
    lessons: [c34, c35, c36],
  },
  {
    title: 'Standard Library',
    lessons: [c37, c38, c39, c40],
  },
  {
    title: 'Object-Oriented Programming',
    lessons: [c41, c42, c43, c44, c45],
  },
  {
    title: 'Algorithms & Functional Tools',
    lessons: [c46, c47, c48],
  },
  {
    title: 'Putting It All Together',
    lessons: [c49, c50],
  },
];

// Flat keyed map for O(1) lookup by lesson ID
export const LESSONS = Object.fromEntries(
  [...UNITS.flatMap((u) => u.lessons), introLesson].map((l) => [l.id, l])
);
